import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';


@Injectable({
    providedIn: 'root'
})
export class FileUploadService {

    constructor(private _http: HttpClient) {
    }

    uploadFileToUrl(file: File, clientId: string, baseUrl: string): Observable<any> {
        const endpoint = `${baseUrl}/client/${clientId}/document`;
        const formData: FormData = new FormData();
        formData.append('document', file, file.name);
        let headers = new HttpHeaders();
        headers = headers.append('Content-Type', 'file-upload');
        headers = headers.append('Accept', 'multipart/form-data');

        return this._http.post(endpoint, formData, {
            observe: 'events',
            headers
        });
    }
}

export interface ClientDocument {
    id: string;
    clientId: string;
    contentType: string;
    fileName: string;
    fileSize: string;
    s3Key: string;
}
